import type {
    BuildingContext,
    Message,
    UnifiedAIRequest,
} from '@quipex/shared/contracts';
import type { QuippyScope } from '../models';

export type MessageRequest =
    | {
          type: 'send';
          scope: QuippyScope;
          chatId: string;
          userInput: string;
          adminMode: boolean;
      }
    | {
          type: 'retry';
          scope: QuippyScope;
          chatId: string;
          messageId: string;
          adminMode: boolean;
      }
    | {
          type: 'edit-resend';
          scope: QuippyScope;
          chatId: string;
          messageId: string;
          userInput: string;
          adminMode: boolean;
      }
    | {
          type: 'select-document';
          scope: QuippyScope;
          chatId: string;
          messageId: string;
          fileId: string;
      };

export function toQuippySessionKey(scope: QuippyScope): string {
    return scope.kind === 'building'
        ? `building:${scope.buildingId}`
        : 'portfolio';
}

export function fromQuippySessionKey(key: string): QuippyScope {
    return key === 'portfolio'
        ? { kind: 'portfolio' }
        : { kind: 'building', buildingId: key.slice('building:'.length) };
}

export function buildPostModel(options: {
    scope: QuippyScope;
    buildingContext?: BuildingContext;
    userInput: string;
    conversationHistory: Message[];
    selectedFileId?: string;
    explicitRoute?: NonNullable<UnifiedAIRequest['explicitRoute']>;
}): UnifiedAIRequest {
    const payload: UnifiedAIRequest = {
        explicitRoute: options.explicitRoute,
        userInput: options.userInput,
        conversationHistory: options.conversationHistory,
        selectedFileId: options.selectedFileId,
    };

    if (!options.explicitRoute && options.scope.kind === 'building') {
        payload.buildingContext = options.buildingContext ?? {
            identifier: options.scope.buildingId,
            buildingName: '',
        };
    }

    return payload;
}
